<!-- 解决方案 -->
<template>
  <div ref="solve" class="solve">
    <div v-html="arrList.content"></div>
    <!-- 底部 定制 -->
    <div class="styleBox_07" :style="{backgroundImage:'url('+ bgUrl +')'}">
      <p>智能化网络安全保障服务，即刻开启！</p>
      <a href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span @click="toPlan">立即定制</span>
      </a>
    </div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    return {
      arrList: [],
      bgUrl: ''
    }
  },
  methods: {
    getInfo () {
      let pageId = this.$route.query.id ? this.$route.query.id : ''
      let infoId = this.$route.query.childId ? this.$route.query.childId : ''
      let arr = JSON.parse(localStorage.getItem('navList'))
      arr.forEach(item => {
        if (item.id == pageId) {
          item.articleList.forEach(items => {
            if (items.id == infoId) {
              this.arrList = items
            }
          })
        }
      })
    },

    toPlan () {
      this.$router.push('/getPlan')
    }
  },
  mounted () {
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
    this.getInfo()
  },
  destroyed () {
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        this.getInfo()
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 移动端样式
@media only screen and (max-width: 1024px) {
  .solve {
    padding-top: 2.75rem;
  }
  .styleBox_07 {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2.125rem 0 1.5625rem;
  }
  .styleBox_07 p {
    font-size: 1rem;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 1.5625rem;
  }
  .comButton {
    color: #fff;
    border-radius: 1rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 1.875rem;
    font-size: 0.8125rem;
    margin: 0;
    padding: 0;
    max-width: 6.6875rem;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .solve {
    background: #fff;
  }
  .styleBox_07 {
    width: 100%;
    height: 320px;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .styleBox_07 p {
    font-size: 32px;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 44px;
  }
  .comButton {
    color: #fff;
    border-radius: 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 50px;
    font-size: 18px;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
}
</style>
<style type="text/css">
@media only screen and (max-width: 1024px) {
  .banner {
    width: 100%;
    position: relative;
  }
  .banner img{
    width: 100%;
  }
  .bannerImg {
    width: 100%;
  }
  .bannerImg img {
    width: 100%;
  }
  .bannerText {
    /* width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center; */
    position: absolute !important;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .bannerText div {
    text-align: center;
  }
  .bannerText h3 {
    font-size: 1.0625rem;
    font-weight: bold;
    border: 0.0625rem solid #fff;
    padding: 0.75rem 1.5rem;
    display: inline-block;
    margin: 0;
    margin-bottom: 0.93rem;
  }
  .bannerText p {
    font-size: 0.6375rem;
    margin: 0;
  }
  .bannerText p {
    font-size: 0.9375rem;
    margin: 0;
  }
  .currencyTitle {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .currencyTitle img {
    width: 2.1rem;
    height: 1.75rem;
  }
  .currencyTitle h3 {
    font-size: 1.0625rem;
    font-weight: 600;
    color: #08142a;
    margin: 0;
    margin-left: 0.6875rem;
    padding: 2.625rem 0;
  }
}
@media only screen and (min-width: 1024px) {
  .banner {
    position: relative;
    height: 50vh;
    overflow: hidden;
  }

  .banner .bannerText {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .banner .bannerText div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .banner .bannerText div h3 {
    font-size: 52px;
    font-weight: bold;
    color: #ffffff;
    line-height: 78px;
    letter-spacing: 5px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    padding: 16px 51px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    margin-bottom: 37px;
  }

  .banner .bannerText div p {
    font-size: 30px;
    font-weight: bold;
    color: #ffffff;
    line-height: 42px;
    letter-spacing: 2px;
  }

  .banner .bannerImg {
    width: 100%;
  }
  .banner img {
    width: 100% !important;
  }

  .comButton {
    padding: 15px 36px;
    color: #fff;
    border-radius: 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    height: 50px;
  }

  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }

  .currencyTitle {
    display: flex;
    justify-content: center;
    margin: 110px 0 85px 0;
  }

  .currencyTitle img {
    width: 69px;
    height: 54px;
  }

  .currencyTitle h3 {
    color: #08142a;
    font-size: 32px;
    font-weight: bold;
    line-height: 45px;
    margin-left: 22px;
  }

  .styleBox_07 {
    width: 100%;
    height: 320px;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .styleBox_07 p {
    font-size: 32px;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 44px;
  }
  .unsetLi {
    display: none;
  }
  .companyDo .companyDo_inner .companyDo_innerB ul li{
    padding: 96px 35px 73px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/solve.vue